import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  inbound_items_form_details: [],
};

const getters = {
  allInboundItemsFormDetails: (state) => state.inbound_items_form_details,
};

const actions = {
  async fetchInboundItemsFormDetails({ commit }, params = {}) {
    try {
      const response = await axios.get("/inbound-items-form-detail", { params: prm(params) });
      commit("setInboundItemsFormDetails", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch inbound_items_form_details:", error);
    }
  },
  async createInboundItemsFormDetail({ commit }, inbound_items_form_detail) {
    try {
      const response = await axios.post("/inbound-items-form-detail", inbound_items_form_detail);
      commit("addInboundItemsFormDetail", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create inbound_items_form_detail:", error);
      throw error;
    }
  },
  async fetchInboundItemsFormDetailById(_, id) {
    try {
      const response = await axios.get(`/inbound-items-form-detail/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch inbound_items_form_detail:", error);
      throw error;
    }
  },
  async updateInboundItemsFormDetail({ commit }, inbound_items_form_detail) {
    try {
      const response = await axios.put(`/inbound-items-form-detail/${inbound_items_form_detail.id}`, inbound_items_form_detail);
      commit("updateInboundItemsFormDetail", response.data);
    } catch (error) {
      console.error("Failed to update inbound_items_form_detail:", error);
      throw error;
    }
  },
  async deleteInboundItemsFormDetailById({ commit }, id) {
    try {
      const response = await axios.delete(`/inbound-items-form-detail/${id}`);
      commit("removeInboundItemsFormDetail", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete inbound_items_form_detail:", error);
      throw error;
    }
  },
};

const mutations = {
  setInboundItemsFormDetails(state, inbound_items_form_details) {
    state.inbound_items_form_details = inbound_items_form_details.data; // Ensure this matches your API's response structure
  },
  addInboundItemsFormDetail(state, inbound_items_form_detail) {
    state.inbound_items_form_details.push(inbound_items_form_detail);
  },
  updateInboundItemsFormDetail(state, updatedInboundItemsFormDetail) {
    const index = state.inbound_items_form_details.findIndex(
      (inbound_items_form_detail) => inbound_items_form_detail.id === updatedInboundItemsFormDetail.id
    );
    if (index !== -1) {
      state.inbound_items_form_details.splice(index, 1, updatedInboundItemsFormDetail);
    }
  },
  removeInboundItemsFormDetail(state, id) {
    state.inbound_items_form_details = state.inbound_items_form_details.filter(
      (inbound_items_form_detail) => inbound_items_form_detail.id !== id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
